import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Project } from '../objects/project';
import { ProjectApiService } from '../services/project-api.service';
import { SaveProjectService } from '../services/save-project.service';
import { UserApiService } from '../services/user-api.service';
import { ProjectInfo } from '../types';


@Injectable({
  providedIn: 'root',
})
export class PaymentGuard  {
  constructor(
    private saveProjectService: SaveProjectService,
    private userApiService: UserApiService,
    private projectApiService: ProjectApiService,
  ) {}

  public canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (localStorage.token) {
      return new Observable((sub) =>
        this.projectApiService.getProject().subscribe((project: Project) => {
          if (!project.canUserAccessProject) {
            return this.projectApiService.getProjectInfo().pipe(take(1)).subscribe((projectInfo: ProjectInfo) => {
              const projectData = {
                description: this.saveProjectService.generateProjectDescription(project),
                name: projectInfo
                  ? projectInfo.name
                  : this.saveProjectService.generateDefaultProjectName(),
              };
              return this.userApiService.saveProject(projectData).subscribe(() =>
                this.projectApiService.newProject().subscribe(() => {
                  return sub.next(true);
                }),
              );
            });
          } else {
            return sub.next(true);
          }
        }),
      );
    } else {
      return true;
    }
  }
}
